"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serverUrl = void 0;
/* istanbul ignore next */
var gl = ((typeof window !== 'undefined' ? window : global) || {});
// GIPHY_API_URL is made to override the api url in testing environments
// must be specified before the packages load
exports.serverUrl = gl.GIPHY_API_URL || 'https://api.giphy.com/v1/';
//# sourceMappingURL=constants.js.map